import { Itinerary } from './itineray.model';
import { BaseEntity } from "./base-entity.model";

import * as firebase from "firebase/app";
import "firebase/firestore";

export class ItinerarySnapshot extends BaseEntity {
  itinerary: Itinerary;
  timestamp: firebase.firestore.Timestamp;

  constructor(object: object = {}) {
    super(object);
  }
}
